import type { ReactNode } from 'react';
import { Children } from 'react';
import type { FCh } from 'react-fc';
import styled from 'styled-components';

/**
 * A container for a collection of ExpandableDetail items
 */
export const ExpandableList: FCh = ({ children }) => {
    return (
        <StyledDisplayList>{Children.map(children, (child: ReactNode) => child && <li>{child}</li>)}</StyledDisplayList>
    );
};

const StyledDisplayList = styled.ul`
    > li {
        padding: var(--size-grid-half) 0;
        border-top: 1px solid var(--color-lines-listDivider);

        &:last-child {
            border-bottom: 1px solid var(--color-lines-listDivider);
        }
    }
`;
